import { TINT_COLOR_UPDATED_EVENT } from '../consts/tint-custom-events.consts';
import { TTintColor } from '../types/tint-color.type';

export const dispatchTintColorUpdatedCustomEvent = (
  tintColorUpdatedCustomEventPayload: TTintColor | null
) => {
  document.body.dispatchEvent(
    new CustomEvent(TINT_COLOR_UPDATED_EVENT, {
      cancelable: true,
      bubbles: true,
      composed: true,
      detail: tintColorUpdatedCustomEventPayload,
    })
  );
};
